<template>
    <div class="container" :class="{ 'fixed': $refs.recipeModal && $refs.recipeModal.active }" :style="section.bgColor ? 'background-color: #D2E6A4' : 'background-color: white'">
        <div 
        class="top-banner tag-partner" v-if="banner && $root.source !== 'enel'"
        :style="(this.$route.path != '/checkout/ricette' && this.$route.path != '/bottega' && ((['shop', 'recipe']).indexOf(this.$route.name) <= 0)) ? 'display: none'  : ''">
            <span v-if="lastConfirmedOrder">Attenzione! Hai già un ordine confermato che puoi modificare entro <b>{{dateCutOff()}}</b>. Ignora questo messaggio se vuoi effettuare un nuove ordine</span>
            <span v-else>Verifica sempre la data di consegna prima di confermare la tua spesa!</span>
            <i class="pl-5 fas fa-times fa-2xl" @click="removeBanner"></i>
        </div>
        <div v-if="loadingMenu || !order">
        <!-- <div class="recipes-listing pt-10">
            <loading-placeholder
                class="recipe-box"
                v-for="n in 12"
            />
        </div> -->
        <div style="padding-top: 150px">
            <cooking-loader class="ma-auto"/>
        </div>

        </div>
        <div v-if="section">
            <div :class="{ 'content-layout': !billIsActive }">
                    <div
                        class="recipes"
                        :class="{'pt-15' : !$mq.isDesktop()}"
                        v-show="$mq.isDesktop() || !$mq.isDesktop() && !billIsActive"
                        style='flex: 1;overflow:hidden;'
                    >   
                        <div v-if="menuState === 'active'">

                                    <div v-if="section.type == 'menu'">
                                        <snackbar-recipes class="tag-partner"/>
                                        <div v-if="menu" class="flex flex-column">
                                            <h2
                                                class="center"
                                                :class="{'placeholder-line': loadingMenu}"
                                                v-html="menu && `${ $t('components.recipes.current_week.title', {
                                                    from: $_dates_readableDay(menu.date.start),
                                                    to: $_dates_readableDayMonth(menu.date.to)
                                                }) }`"
                                            />

                                            <!-- <p
                                                class="center"
                                                :hidden="!menu"
                                            >

                                                <plan-select
                                                    ref="plans"
                                                    :updating.sync="updating"
                                                />
                                            </p> -->

                                            <span class="center px-3">Ogni settimana un nuovo menù. Più porzioni ordini più risparmi!</span>
                                            <p class="center link-detail mt-5" @click="goDown()">
                                                <span class="pr-1">Quanto costano i kit ricette?</span>
                                                <i class="fas fa-info-circle fa-lg" style="color: rgb(57, 158, 201);"/>
                                            </p>
                                        </div>

                                        <template>
                                            <!--<h2 class="center">{{ section.title || "Title is missing in section" }}</h2>
                                            <p class="center">{{ section.subtitle || "Subtitle is missing in section" }}</p>-->
                                            <!-- Filtri desktop Ricette -->
                                            <div class="ml-15 my-2 flex" v-if="$mq.isDesktop()">
                                                <v-btn small color="var(--quomi-primary)" class="filter-btn" style="color:white; outline:none;" @click="openBox()">
                                                    <span class="text-bold capitalize pr-3">Filtri</span>
                                                    <i class="fas fa-angle-down" :class="{ 'rotated': openedBox }"></i>
                                                </v-btn>
                                                <transition name="modal-on">
                                                    <div class="cat_box mt-10" v-if="openedBox">   
                                                        <h4>Tipologia</h4>  
                                                                                                     
                                                        <div v-for="(filter) in section.filters.type" style="line-height: 2rem;" >   
                                                            <span class="flex align-items-center" v-if="filter.category">
                                                                <input class="link-detail mr-3" type="checkbox" :id="filter.category" :value="filter.values" v-model="filteredRecipes" @click="openBox()">
                                                                {{filter.category}}
                                                            </span>          
                                                            <span class="flex align-items-center" :for="filter.value" v-else>
                                                                <input class="link-detail mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredRecipes" @click="openBox()">
                                                                {{$t(filter.value)}}
                                                            </span>                                                                                                                                                                                                                                             
                                                        </div>
                                                        <h4 class="mt-2">Tempo</h4> 
                                                        <div v-for="(filter) in section.filters.time" style="line-height: 2rem;" >           
                                                            <span class="flex align-items-center" :for="filter.value">
                                                                <input class="link-detail mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredRecipesByTime" @click="openBox()">
                                                                {{filter.value.label}}
                                                            </span>                                                                                                                                                                                                                                             
                                                        </div>                                                                                                          
                                                    </div>
                                                </transition>
                                                <div class="inline ml-15 text-body-mid">
                                                    
                                                    <span class="text-bold" v-if="filteredRecipes.length > 0">Tipologia:</span>
                                                    <div class='inline ml-3' v-for="(item,index) in filteredRecipes" :key="index">
                                                        <v-chip
                                                            v-if="typeof(item) === 'object'" 
                                                            :key="index" 
                                                            filter 
                                                            small
                                                            close 
                                                            close-icon="fas fa-times-circle" 
                                                            color="var(--quomi-primary)" 
                                                            class="ml-3 text-bold" 
                                                            style="color: white"
                                                            @click:close="filteredRecipes.splice(index,1)"
                                                            >
                                                            {{$t(item[0])}}                                                                                             
                                                        </v-chip>
                                                        <v-chip
                                                            v-if="typeof(item) === 'string'" 
                                                            filter 
                                                            small
                                                            close 
                                                            close-icon="fas fa-times-circle" 
                                                            color="var(--quomi-primary)" 
                                                            class="ml-3 text-bold" 
                                                            style="color: white"
                                                            @click:close="filteredRecipes.splice(index,1)"
                                                            >                           
                                                            {{$t(item)}}                                                                                                      
                                                        </v-chip>
                                                    </div>
                                                    <span class="ml-3 text-bold" v-if="filteredRecipesByTime.length > 0">Tempo:</span>
                                                    <div class='inline ml-3' v-for="(item,index) in filteredRecipesByTime" :key="index">
                                                        <v-chip
                                                            filter 
                                                            small
                                                            close 
                                                            close-icon="fas fa-times-circle" 
                                                            color="var(--quomi-primary)" 
                                                            class="ml-3 text-bold" 
                                                            style="color: white"
                                                            @click:close="filteredRecipesByTime.splice(index,1)"
                                                            >
                                                            {{item.label}}                                                                                                          
                                                        </v-chip>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Filtri mobile Ricette -->
                                            <div v-else class="flex justify-content-center">
                                                <div class="filter-btn-mobile flex-vcenter" @click="toggleFilters">
                                                    Filtri 
                                                    <v-chip 
                                                        v-if="filteredRecipes.length !== 0 || filteredRecipesByTime.length !== 0"
                                                        class="ml-3 text-bold"
                                                        outlined
                                                        color="var(--quomi-primary)"
                                                    >
                                                        {{filteredRecipes.length || filteredRecipesByTime.length}}
                                                    </v-chip>
                                                    <i class="fas fa-sliders-h flex-right"></i>
                                                </div>
                                                <transition name="slide-fade">
                                                    <div class="overlay" v-if="openedFilters" :style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]">
                                                        <div class="filters-viewpoint">
                                                            <div class="flex justify-content-between mr-5">
                                                                <h3 class="mt-5 ml-5">Tipologia</h3>
                                                                <v-icon @click="toggleFilters" large color="var(--quomi-primary)">fas fa-times-circle</v-icon>
                                                            </div>
                                                            <div class="mb-5 ml-5 flex flex-column flex-wrap">                                               
                                                                <div v-for="(filter, index) in section.filters.type" :key="index"> 
                                                                    <span class="filter-item flex" v-if="filter.category">
                                                                        <input class="mr-3" type="checkbox" :id="filter.category" :value="filter.values" v-model="filteredRecipes" />
                                                                        {{filter.category}}
                                                                    </span>                                                                                                                                                                                                                                                                                                                  
                                                                    <span class="filter-item flex" :for="filter.value" v-else>
                                                                        <input class="mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredRecipes" /> 
                                                                        {{$t(filter.value)}}
                                                                    </span>                                              
                                                                </div> 
                                                            </div>
                                                            <h3 class="ml-5">Tempo:</h3>
                                                            <div class="mb-5 ml-5 flex flex-column flex-wrap">                                               
                                                                <div v-for="(filter, index) in section.filters.time" :key="index">                                                                                                                                                                                                                                                                                                                   
                                                                    <span class="filter-item flex" :for="filter.value">
                                                                        <input class="mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredRecipesByTime" /> 
                                                                        {{filter.value.label}}
                                                                    </span>                                              
                                                                </div> 
                                                            </div>
                                                            <div class="filters-footer flex-center" :style="[$_appViewPosition_positionBottom]">
                                                                <CTA
                                                                    :content="`Applica`"
                                                                    @click="toggleFilters"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="recipes-listing" v-if="menu">
                                                <recipe-box
                                                    v-for="(item, index) in getRecipes()"
                                                    :key="`box-${index}`"
                                                    v-if="item"
                                                    :item="item"
                                                    :quantity="$_orderAction_getRecipeQuantity(item)"
                                                    :availability="getRecipeAvailability(item)"
                                                    @openRecipe="$refs.recipeModal.open(item)"
                                                    @recipeAction="recipeAction"
                                                    :class="{   
                                                        'disabled': (isMaxRecipesReached || isOrderHasMixedBox || !order) && !isRecipeInBox(item),
                                                    }"
                                                    :isRecipeAvailable="recipeAvailable(item)"
                                                    :isRecipeInBox="isRecipeInBox(item.id)"
                                                    :maxReached="isOrderHasMixedBox"
                                                    isActionAllowed
                                                    isHover
                                                    :updating="updating"
                                                />
                                            </div>
                                        </template>
                                        <div >
                                            <plans :full="false" :without-table="true" id="plans-guide" class="bg-soft-green" />
                                        </div>
                                    </div>


                                    <div v-if="section.type == 'shop'"  >
                                        <snackbar class="tag-partner"/>
                                        <template>
                                            <div class="center mb-5" v-if="section.logo">
                                                <img :src="section.logo" :width="section.logoWidth"/>
                                            </div>
                                            <v-breadcrumbs class="pt-0" :class="{'pt-5 pl-5' : !$mq.isDesktop()}">
                                                <span @click="historyBack" class="text-bold link-detail" :class="{'pl-10' : $mq.isDesktop()}" style="color: var(--quomi-primary)">
                                                    <i class="fas fa-chevron-left mr-2"/>Bottega
                                                </span> 
                                            </v-breadcrumbs>
                                            <div :style="{color: section.fontColor}">
                                                <h2 class="center">{{ section.title || "Title is missing in section" }}</h2>
                                                <p class="center">{{ section.subtitle || "Subtitle is missing in section" }}</p>
                                            </div>
                                            <!-- Filtri desktop Extra -->
                                            <div class="ml-15 mt-10 flex justify-content-between" v-if="$mq.isDesktop()">
                                                <v-btn small color="var(--quomi-primary)" style="color: white; outline:none;" class="filter-btn align-self-center mb-5" @click="openBox()">
                                                    <span class="text-bold capitalize pr-3">Filtri</span>
                                                    <i class="fas fa-angle-down" :class="{ 'rotated': !openedBox }"></i>
                                                </v-btn>
                                                <transition name="modal-on">
                                                    <div class="cat_box mt-10" v-if="openedBox">                                                                                                          
                                                        <div v-for="(filter, index) in section.filters" :key="index"  style="line-height: 2rem;" >           
                                                            <span class="flex align-items-center" :for="filter.value" v-if="filter.field === 'tags'">
                                                                <input class="link-detail mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredProducts" @click="openBox()">
                                                                {{filter.value}}
                                                            </span>
                                                            <span class="flex align-items-center" :for="filter.value" v-else-if="filter.field === 'cg1'">
                                                                <input class="link-detail mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredProductsCg1" @click="openBox()">
                                                                {{filter.value}}
                                                            </span>                                                                                                                                                                                                                                              
                                                            <span class="flex align-items-center" :for="filter.value" v-else>
                                                                <input class="link-detail mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredProductsCg2" @click="openBox()"> 
                                                                {{$t(filter.value)}}
                                                            </span> 
                                                        </div>                                                                                                           
                                                    </div>
                                              </transition>
                                              <span class="ml-10" style="font-size: 18px">
                                                <div class='inline' v-for="(item,index) in filteredProducts" :key="index">
                                                    <v-chip
                                                        outlined  
                                                        medium
                                                        close 
                                                        close-icon="fas fa-times-circle" 
                                                        color="var(--quomi-primary)" 
                                                        class="ml-3 text-bold"                                                        
                                                        @click:close="filteredProducts.splice(index,1)"
                                                        >
                                                        {{$t(item)}}                                                                                                            
                                                    </v-chip>
                                                </div>
                                                <div class='inline' v-for="(item,index) in filteredProductsCg1" :key="index">
                                                    <v-chip
                                                        outlined  
                                                        medium
                                                        close 
                                                        close-icon="fas fa-times-circle" 
                                                        color="var(--quomi-primary)" 
                                                        class="ml-3 text-bold"                                                         
                                                        @click:close="filteredProductsCg1.splice(index,1)"
                                                        >
                                                        {{$t(item)}}                                                                                                            
                                                    </v-chip>
                                                </div>
                                                <div class='inline' v-for="(item,index) in filteredProductsCg2" :key="index">
                                                    <v-chip
                                                        outlined 
                                                        small
                                                        close 
                                                        close-icon="fas fa-times-circle" 
                                                        color="var(--quomi-primary)" 
                                                        class="ml-3 text-bold"                                                       
                                                        @click:close="filteredProductsCg2.splice(index,1)"
                                                        >
                                                        {{$t(item)}}                                                                                                             
                                                    </v-chip>
                                                </div>
                                              </span>
                                              <div class="mr-15 mb-1">
                                                  <v-select
                                                    v-if="!section.tags.includes('Natale')"
                                                    dense                                     
                                                    hide-selected
                                                    :prepend-icon="sortingBy.length > 0 ? 'fas fa-times-circle': ''"
                                                    label="Ordina per"
                                                    :items="section.sorting"
                                                    item-text="name"
                                                    item-value="value" 
                                                    @click:prepend="clearSelect"                                             
                                                    v-model="sortingBy"                                                                             
                                                  >
                                                  </v-select>
                                               <!--  <v-btn small color="var(--quomi-primary)" style="color: white; outline:none;" class="filter-btn" @click="openSortBox()">
                                                  <span class="text-bold capitalize pr-3">Ordina per</span>
                                                  <i class="fas fa-angle-down" :class="{ 'rotated': !openedSortBox }"></i>
                                                </v-btn>
                                                <transition name="modal-on">
                                                    <div class="cat_box cat_box_sort mt-3" v-if="openedSortBox">  
                                                        <div v-for="(sort, index) in section.sorting" :key="index"  style="line-height: 2rem;" >   
                                                            <div :class="{'disabled': sortingBy.find(el => el != sort.value)}" class="flex align-items-center justify-content-end"> 
                                                                <span class="mr-3">{{sort.name}}</span>           
                                                                <input :disabled="sortingBy.find(el => el != sort.value)" type="checkbox" :id="sort.value" :value="sort.value" v-model="sortingBy" @click="openSortBox()">
                                                            </div> 
                                                        </div>                                                                                                        
                                                    </div>
                                                </transition> -->
                                              </div>
                                            </div>
                                             
                                            <!-- Filtri mobile Extra -->
                                            <div v-else>
                                                <div class="flex justify-content-around">
                                                    <div class="filter-btn-mobile flex-vcenter" @click="toggleFilters">
                                                        Filtri 
                                                        <v-chip 
                                                            v-if="filteredProducts.length !== 0 || filteredProductsCg1.length !== 0 || filteredProductsCg2.length !== 0"
                                                            class="ml-3 text-bold"
                                                            outlined
                                                            color="var(--quomi-primary)"
                                                        >
                                                            {{filteredProducts.length || filteredProductsCg1.length || filteredProductsCg2.length }}
                                                        </v-chip>
                                                        <i class="fas fa-sliders-h flex-right"></i>                                                
                                                    </div>
                                                    <div class="filter-btn-mobile flex-vcenter" @click="toggleSorting" v-if="!section.tags.includes('Natale')">
                                                        Ordina per
                                                        <i class="fas fa-sliders-h flex-right"></i>                                                
                                                    </div>
                                                </div>
                                              <transition name="slide-fade">
                                                <div class="overlay" v-if="openedFilters" :style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]">
                                                  <div class="filters-viewpoint">
                                                    <div class="flex justify-content-end mr-5">                                                       
                                                        <v-icon @click="toggleFilters" large color="var(--quomi-primary)">fas fa-times-circle</v-icon>
                                                    </div>
                                                    <h3 class="mt-5 ml-5">Tipologia</h3>
                                                    <div class="my-5 ml-5 flex flex-column flex-wrap">                                               
                                                        <div v-for="(filter, index) in section.filters" :key="index">           
                                                            <span class="filter-item flex" :for="filter.value" v-if="filter.field === 'tags'">
                                                                <input class="mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredProducts" />
                                                                    {{$t(filter.value)}}  
                                                            </span>
                                                            <span class="filter-item flex" :for="filter.value" v-else-if="filter.field === 'cg1'">
                                                                <input class="mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredProductsCg1" />
                                                                    {{$t(filter.value)}}  
                                                            </span>                                                                                                                                                                                                                                                                                                        
                                                            <span class="filter-item flex" :for="filter.value" v-else>
                                                                <input class="mr-3" type="checkbox" :id="filter.value" :value="filter.value" v-model="filteredProductsCg2" /> 
                                                                    {{$t(filter.value)}}
                                                            </span>                                              
                                                        </div> 
                                                    </div>
                                                    <div class="filters-footer flex-center" :style="[$_appViewPosition_positionBottom]">
                                                      <CTA
                                                          :content="`Applica`"
                                                          @click="toggleFilters"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="overlay" v-if="openedSorting" :style="[$_appViewPosition_positionTop, $_appViewPosition_positionBottom]">
                                                    <div class="filters-viewpoint">
                                                        <div class="flex justify-content-end mr-5">                                                       
                                                            <v-icon @click="toggleSorting" large color="var(--quomi-primary)">fas fa-times-circle</v-icon>
                                                        </div>
                                                        <h3 class="mt-5 ml-5">Ordina per</h3>
                                                        <div class="my-5 ml-5 flex flex-column flex-wrap">                                               
                                                        <div v-for="(sort, index) in section.sorting" :key="index">           
                                                            <span :class="{'disabled': sortingBy.find(el => el != sort.value)}" class="filter-item flex" :for="sort.value">
                                                                <input :disabled="sortingBy.find(el => el != sort.value)" class="mr-3" type="checkbox" :id="sort.value" :value="sort.value" v-model="sortingBy" />
                                                                    {{sort.name}}  
                                                            </span>                                           
                                                        </div> 
                                                    </div>  
                                                    <div class="filters-footer flex-center" :style="[$_appViewPosition_positionBottom]">
                                                      <CTA
                                                          :content="`Applica`"
                                                          @click="toggleSorting"
                                                      />
                                                    </div>                     
                                                    </div>                            
                                                </div>
                                              </transition>
                                            </div>
                                            <div class="recipes-listing">
                                                <!-- <extra-box                                       
                                                    class="recipe-box"
                                                    v-for="(product, index) in getProductsByTags()"
                                                    :key="index"
                                                    :item="product"
                                                    :order.sync="orderStore.order"
                                                    @openModalExtra="$refs.modalExtra.open(product)"
                                                    :updating.sync="updatingProducts"
                                                    :actionExecuted.sync="actionExecuted"
                                                    :maxAvailable="section.max >= 0 ? section.max : 999"
                                                >
                                                </extra-box> -->
                                                <div class="recipe-box recipe-extra-box" :class="{'with-banners' : section.title === 'Aperitivo' || section.title === 'Carne e pesce' || section.title === 'Dolci e colazioni' }" v-for="(product, index) in getProductsByTags()" :key="index">
                                                    <extra-box                                                                                     
                                                        :item="product"
                                                        :order.sync="orderStore.order"
                                                        @openModalExtra="$refs.modalExtra.open(product)"
                                                        :updating.sync="updatingProducts"
                                                        :actionExecuted.sync="actionExecuted"
                                                        :maxAvailable="section.max >= 0 ? section.max : 999"
                                                    >
                                                    </extra-box>
                                                    <!-- Start: Banners Martini -->
                                                    <section 
                                                        class="banner mb-3 mt-7 shadow-box tag-partner"
                                                        v-if="index == 4 && section.title == 'Aperitivo'"
                                                    >
                                                        <div class="flex flex-column align-items-center col col-md-6">
                                                            <h2 style="color: white; text-align: center"> Prepara i tuoi cocktail<br> preferiti a casa <br>con i <b>Kit aperitivo</b> Quomi <br>by Martini</h2>
                                                        </div>
                                                    </section>
                                                    <section 
                                                        class="banner-2 mb-3 mt-7 shadow-box tag-partner"
                                                        v-if="index == 8 && section.title == 'Aperitivo'"
                                                    >
                                                        <img src="https://api.quomi.it/oldimg/logo-martini.webp" alt="martini-logo">
                                                        <div class="flex flex-column align-items-center col-lg-6">
                                                            <h2>Perchè Quomi ha scelto <b>Martini</b>?</h2>
                                                            <p class="mt-5" style="line-height: 1.5; line-break: breakword">I prodotti Martini raccontano la storia di due <b>uomini visionari</b>,
                                                            di una <b>terra fertile</b> dove l'arte della vinicultura incontra le erbe aromatiche. Ogni bottiglia racchiude <b>esperienza e artigianalità</b>.</p>
                                                        </div>
                                                    </section> 
                                                    <!-- End: Banners Martini -->
                                                   
                                                    <!-- Start: Banner Babbi -->
                                                    <section 
                                                        class="banner-2 mb-3 mt-7 shadow-box tag-partner"
                                                        v-if="index == 4 && section.title == 'Dolci e colazioni' && filteredProducts.length == 0 && filteredProductsCg1.length == 0 && filteredProductsCg2.length == 0"
                                                    >
                                                        <img class="col-3" src="https://api.quomi.it/oldimg/logo-babbi.png" alt="fileni-logo">
                                                        <div class="flex flex-column align-items-center col-md-7">
                                                            <h2>Perchè Quomi ha scelto <b>Babbi</b>?</h2>
                                                            <ul class="mt-5" style="line-break: breakword">
                                                                <li>Per Babbi la qualità dei propri prodotti è un principio fondamentale</li>
                                                                <li>Anni di esperienza, amore per la tradizione e grande passione per l'arte dolciaria</li>
                                                                <li>Vengono impiegate solo materie prime nobili e naturali, accuratamente scelte e dosate secondo la classica tradizione artigianale italiana</li>
                                                            </ul>
                                                        </div>
                                                    </section>
                                                    <!-- End: Banner Babbi -->
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                        </div>
<!--                         <div class="recipes-listing" v-if="!order">
                            <loading-placeholder
                                class="recipe-box"
                                v-for="n in 6"
                            />
                        </div> -->

                        <div
                            class="recipes-listing"
                            v-if="menuState === 'disactive'"
                        >
                            <br><br>
                            Menù non disponibile.
                            <br><br>
                        </div>
                    </div>
            </div>

            <checkout-footer
                :ctaLabel="$t('components.checkout.next')"
                v-if="!$mq.isOffline()"
                @confirm="confirm"
                :error="errorStore.message"
                :loading="updating"
                :recipesFooter="$route.path !== '/checkout/ricette' ? false : true"
            />

            <!--<banner-tips
                v-show="menu"
                :recipesInBox="recipes"
                :menu="menu"
            />-->

            <top-sku-modal
                ref="skuModal"  
                @passToNextStep="passToNextStep"
            />

            <recipe-modal
                ref="recipeModal"
                @recipeAction="recipeAction"
                :updating="updating"
                :isMaxRecipesReached="isMaxRecipesReached"
                :recipes="recipes"
            />

            <wishlist-widget
                :wishlistMode="wishlistMode"
                :wishlist="wishlist"
                :link="$_wishlist_wishlistLink"
                :wishlistRecipes="$_wishlist_wishlistRecipes"
                v-if="!billIsActive"
            />
            <extra-modal
                ref="modalExtra"
                :user="user"
                :order.sync='orderStore.order'
                :updating.sync="updating"
                :action="false"
            />

            <general-error />

            <modal-warning
                ref="warning"
            />
        </div>
    </div>
</template>

<script type = "text/javascript" >
import CheckoutFooter from './CheckoutFooter'
import CheckoutVerifyCoverage from './CheckoutVerifyCoverage'
import GeneralError from './GeneralError'
import RecipeModal from '../RecipeModal'
import TopSkuModal from './TopSkuModal'
import RecipeBox from '../RecipeBox'

import MenuAlert from './MenuAlert'
import BannerTips from './BannerTips'
import PlanSelect from './PlanSelect'
import ModalWarning from './ModalWarning'
import SubscribedBill from './SubscribedBill'
import ExtraBox from '../Ecommerce/ExtraBox'
import ExtraModal from '../Ecommerce/ExtraModal'
import Plans from '../Plans'


import WishlistWidget from '../SocialShare/WishlistWidgetNR'

import { dates } from '../../mixins/dates'
import { dataLayer } from '../../mixins/gtc'
import { sections } from '../../mixins/sections'
import { wishlist } from '../../mixins/wishlist'
import { orderAction } from '../../mixins/orderAction'
import { ExtraApi } from '../../api/ExtraApi'
import CookingLoader from '../../CookingLoader'
import { Order } from '../../core/Order'
import { Extras } from '../../core/Extras'
import { container } from '../../services/container'
import { UserApi } from '../../api/UserApi'
import { subscriptionStore } from '../../store/subscriptionStore'
import { deliveryStore } from '../../store/deliveryStore'
import { orderStore } from '../../store/orderStore'
import { plansStore } from '../../store/plansStore'
import { errorStore } from '../../store/errorStore'
import { menuStore } from '../../store/menuStore' 
import { stepStore } from '../../store/stepStore' 
import { deliverySelect } from '../../mixins/delivery'

import { deliveryContainer } from '../../mixins/deliveryContainer'

import { shipmentDayChanging } from '../../mixins/shipmentDayChanging'

const moment = require('moment')

import { Repository } from '../../services/Repository'
import { scrollToElementId, debounce } from '../../assets/js/main'
import Snackbar from '../Elements/Snackbar'
import SnackbarRecipes from '../Elements/SnackbarRecipes'



export default {
    components: {
        WishlistWidget,
        CheckoutVerifyCoverage,
        SubscribedBill,
        CheckoutFooter,
        GeneralError,
        RecipeModal,
        TopSkuModal,
        PlanSelect,
        BannerTips,
        RecipeBox,
        MenuAlert,
        ModalWarning,
        ExtraBox,
        ExtraModal,
        Plans,
        CookingLoader,
        Snackbar,
        SnackbarRecipes
    },

    mixins: [
        sections,
        shipmentDayChanging,
        deliveryContainer,
        dataLayer,
        wishlist,
        dates,
        orderAction,
        deliverySelect
    ],

    data () {
        return {
            canEdit: null,
            guest: false,
            innerLoading: false,
            subscriptionStore: subscriptionStore.state,
            deliveryStore: deliveryStore.state,
            orderStore: orderStore.state,
            plansStore: plansStore.state,
            errorStore: errorStore.state,
            menuStore: menuStore.state,
            stepStore: stepStore.state,
            loading: false,
            updating: false,
            billIsActive: false,
            actionExecuted: false,
            updatingProducts: false,
            products: [],
            sticky: false,
            openedBox: false,
            openedSortBox: false,
            openedFilters: false,
            openedSorting: false,
            filteredProducts: [],
            filteredProductsCg1: [],
            filteredProductsCg2: [],
            filteredRecipes: [],
            filteredRecipesByTime: [],
            sortingBy: [],
            banner: true,
			pathsWithSections : [
				'/checkout/cassette',
				'/checkout/carne-pesce',
				'/checkout/latticini-salumi',
				'/checkout/frutta-verdura',
				'/checkout/pasta-pane',
				'/checkout/colazioni',
				'/checkout/piatti-pronti',
				'/checkout/vini-birre',
				'/checkout/dispensa',
				'/checkout/aperitivo',
				'/checkout/pizze'
			],
            lastConfirmedOrder: null
        }
    },

    filters: {
        readableDate (val) {
            return moment(val).locale('it').format('dddd D MMMM')
        }
    },

    watch: {
        'order': {
            handler() {
            },
            deep: true
        },
        'menuStore.active': {
            handler () {
                menuStore.redirectHandler()
            },
            immediate: true
        },
        '$route.params.tag': {
            handler() {
                this.innerLoading = true;
                this.loadProducts().then(i => {
                    this.innerLoading = false
                })
            }
        }
    },

    computed: {
        showAlert () {
            return !this.billIsActive
        },
        menu () {
            return this.menuStore.menu
        },

        isOrderOk () {
            return (this.canConfirm) && !this.errorStore.message
        },

        menuState () {
            if (this.loadingMenu) return 'loading'
            if (!this.menu) return 'disactive'
            if (!this.menu.active) return 'disactive'
            if (this.menu.active) return 'active'
        },

        loadingMenu () {
            return this.menuStore.loading || this.innerLoading
        },

        deliveryPrice () {
            if (this.orderStore.order.prices.delivery > 0) return '€ ' + this.orderStore.order.prices.delivery.replace('.', ',')
            return 'gratuita'.toUpperCase()
        },

        isMaxRecipesReached () {
            return this.recipes.length === this.maxRecipes
        },

        boxesInBox () {
            var mixedBoxesIds = [] 
            this.menu.recipes.forEach(recipe => {
                if (recipe.isMixedBox) {
                    mixedBoxesIds.push(recipe.id)
                }
            })

            return this.recipes.filter(element => mixedBoxesIds.includes(element)).length
        },

        isOrderHasMixedBox () {
            return this.boxesInBox >= 1
        },

        availableRecipes() {
            let recipes = this.menu.recipes;   
            let recipesNotAvailable = []
            recipes.forEach((recipe, i) => {                        
                if (recipe.availability <= 0) {  
                    recipesNotAvailable.push(recipes[i]);                               
                }
            })
            recipes = recipes.filter(recipe => recipe.availability > 0).concat(recipesNotAvailable)
            return recipes
        }
    },

    methods: {

        goDown() {
            scrollToElementId("plans-guide",  300, 100)
        },

        maxReached() {

            return this.$_orderAction_maxReached();

        },
        recipeAvailable (recipe) {
            return recipe.available || this.isRecipeInBox(recipe)
        },
        getRecipeAvailability (needle) {

            if (!this.orderStore.order) {
                return 0
            }

            if (this.maxReached()) {
                return 0
            }

            var menuRecipe = this.menu.recipes.find(recipe => {
                return recipe.id === needle.id;
            })
            
            return menuRecipe.availability_all[this.orderStore.order.plan.people]
        },
        getRecipeQuantity (needle) {
            var orderRecipe = this.orderStore.order.recipes.find(recipe => {
                return recipe.id === needle.id
            })

            return orderRecipe ? orderRecipe.quantity : 0;
        },

        load () {
            this.loadRecipes()
            this.loadCurrentPlan()



            // changing shipment day
            return this.$_shipmentDayChanging_loadDelivery()
            .then(response => {
                return this.loadProducts()
            })
            .then(response => {
                return this.loadMenu()
            })

            .then(response => {

                var cookies = container.get('services.cookies')
                var coupon = cookies.get('coupon');

                if (coupon) {
                    cookies.remove('coupon');

                    return orderStore.addCoupon({
                      coupon_code: coupon
                    }).catch(e => {

                    });
                }

                return 1;
            })
      .then(response => {
        let query = Object.assign({}, this.$route.query);

        if (query.recipe_id) {

          let recipe = this.menu.recipes.find(i => { return i.id == query.recipe_id});

          if (recipe) {
            this.updating = true;

            this.$_orderAction_updateRecipe(recipe, 1).then(i => {
              this.updating = false
              delete query.recipe_id
              this.$router.push({ query: query });
            })
          }

        } else if (query.product_id) {
          let rm = new ExtraApi()
          rm.all({query: 'id eq '+query.product_id}).then(response => {

            delete query.product_id

            let extra = response.body.data.resources.length > 0 ? response.body.data.resources[0] : null;

            if (!extra) {
              return;
            }

            this.updating = true;

            this.$_orderAction_addExtra(extra, 1).then(i => {
              this.updating = false
              delete query.product_id
              this.$router.push({ query: query });
            })
          });


          // orderStore.updateOrderParam({ param: 'extra', value: this.parameterExtras })
        }
      })
            .catch(response => {
                throw response
                errorStore.formatMessage(response)
            })
            .finally(response => {
                //this.loadSections()
            })
        },


        loadOrder () {
            if (!this.user) {
                throw "No user found";
            }

            let order = this.user.order ? new Order(this.user.order) : null
            subscriptionStore.state.subscription = this.user.subscription

            if (!this.order) {

            }
        },

        loadRecipes () {
            if (!this.orderStore.order || !this.orderStore.order.recipes)
                return;
        
        },

        getShopTags () {
            if (!this.section) {
                return []
            }
            
            return this.section.tags || []
        },

        getWeight(product) {
        if (product.title.includes('Coca-Cola Original Taste')) {
            return 10
        }
    
        if (product.title.includes('Coca-Cola Zero Zuccheri')) {
            return 20;
        }

        return 5;
        },

        getProductsByTags() {
            if(this.filteredProducts.length == 0 && this.filteredProductsCg1.length == 0 && this.filteredProductsCg2.length == 0) {
                return this.products.filter(product => {
                    return product.tags.some(r=> this.section.tags.includes(r))
                }).sort((a,b) => {
                    if(this.sortingBy.includes("price_down") || this.section.tags.includes("Pasqua")){
                      return b.price - a.price
                    } else if (this.sortingBy.includes("price_up") || this.$root.source === "enel"){
                      return a.price - b.price
                    } /* else if (this.sortingBy.includes("stock")){
                      return b.stock - a.stock
                    } else if (this.sortingBy.includes("fresh")){
                      return a.cg2 == "Fresco" ? -1 : 1
                    } */
                    if (this.section.title == 'Aperitivo') {
                        if(a.stock <= 0 || b.stock <= 0) {
                            return b.stock - a.stock
                        }
                        return b.price - a.price
                    }
                    if(this.section.tags.includes("Natale")) {
                        if(a.stock <= 0 || b.stock <= 0) {
                            return b.stock - a.stock
                        }
                        return b.price - a.price
                    }
                    if (this.section.title == 'Carne e pesce') {
                        if(a.stock <= 0 || b.stock <= 0) {
                            return b.stock - a.stock
                        }
                        return a.product.supplier.name == "Fileni" ? -1 : 1
                    }
                    if (this.section.title == 'Dolci e colazioni') {
                        if(a.stock <= 0 || b.stock <= 0) {
                            return b.stock - a.stock
                        }
                        return a.product.supplier.name == "Babbi" ? -1 : 1
                    }
                    return b.stock - a.stock
                })
            }else if(this.filteredProductsCg1.length > 0){
                return this.products.filter(product => {
                    return this.filteredProductsCg1.includes(product.cg1)
                }).sort((a,b) => {
                    if(this.sortingBy.includes("price_up")){
                        return a.price - b.price
                    } else if (this.sortingBy.includes("price_down")){
                        return b.price - a.price                 
                    } /* else if (this.sortingBy.includes("stock")){
                        return b.stock - a.stock
                    } else if (this.sortingBy.includes("fresh")){
                        return a.cg2 == "Fresco" ? -1 : 1
                    } */
                    return b.stock - a.stock;
                })
            }else if(this.filteredProductsCg2.length > 0) {          
               return this.products.filter(product => {
                    return this.filteredProductsCg2.includes(product.cg2)
                }).sort((a,b) => {
                    if(this.sortingBy.includes("price_up")){
                        return a.price - b.price
                    } else if (this.sortingBy.includes("price_down")){
                        return b.price - a.price                 
                    }/* else if (this.sortingBy.includes("stock")){
                        return b.stock - a.stock
                    }else if (this.sortingBy.includes("fresh")){
                        return a.cg2 == "Fresco" ? -1 : 1
                    } */
                    return b.stock - a.stock;
                }) 
            }else {
                return this.products.filter(product => {
                    return product.tags.some(r=> this.filteredProducts.includes(r))
                }).sort((a,b) => {
                    if(this.sortingBy.includes("price_down") || this.section.tags.includes("Natale")){
                    return b.price - a.price
                    } else if (this.sortingBy.includes("price_up")){
                    return a.price - b.price
                    }/* else if (this.sortingBy.includes("fresh")){
                    return a.cg2 == "Fresco" ? -1 : 1
                    } */
                    if(this.section.tags.includes("Pasqua")) {
                    return a.price - b.price
                    }
                    return b.stock - a.stock;
                }) 
            }
        },

        getRecipes() {
            let recipes = this.availableRecipes

            if(this.filteredRecipes.length > 0){ 
                recipes = recipes.filter(recipe => {
                    return this.filteredRecipes.flat().includes(recipe.product.cg2)
            })
            }
            if(this.filteredRecipesByTime.length > 0) {
                let minRange = ''
                let maxRange = ''
                this.filteredRecipesByTime.forEach(el => {
                    minRange = el.min
                    maxRange = el.max
                })
                recipes = recipes.filter(recipe => {
                    if(maxRange == null) {
                        return recipe.preparation_time >= minRange
                    }
                    return recipe.preparation_time >= minRange && recipe.preparation_time <= maxRange
                })
            }

            return recipes
        },

        clearFilters() {
            this.filteredProducts = []
            this.filteredProductsCg1 = []
            this.filteredProductsCg2 = []
            this.filteredRecipes = []
            this.filteredRecipesByTime = []
            this.sortingBy = []
            this.openedBox = false
            this.openedSortBox = false
            this.openedFilters = false
            this.openedSorting = false
        },

        clearSelect() {
            this.sortingBy= []
        },

        loadProducts() {

            var tags = this.getShopTags();

            var em = new ExtraApi()

            if (tags.length === 0) {
                this.products = []
                return Promise.resolve(1)
            }

            return em.all({
                params: {
                    show: 99999,
                    page: 1,
                    sort_direction: 'asc',
                    query: `shopTags.name in (${tags.map(i => `'${i}'`).join(",")})`
                }
            })
            .then(response => {
                this.products = new Extras(response.body.data.resources)
            })
        },

        loadCurrentPlan () {
            plansStore.state.selectedPlanId = this.user.subscription.plan.id

        },

        loadMenu () {
            return menuStore.loadCurrentMenu(
                orderStore.getWeekPlanId(),
                this.$_deliverySelect_selectedDay 
                    ? this.$_deliverySelect_selectedDay.shipment_day 
                    : moment(this.orderStore.order.date.checkout).add(1, 'days').weekday()
                ).then(i => {
                return plansStore.loadPlans() 
            }).then(i => {
              if (!menuStore.isMenuAvailable()) {
                return;
              }
              if (!this.$route.params.tag || this.sections.length == 0) {

                return this.$router.push({name: 'shop'})
              }
       
              if (!this.section) {
                  return this.$router.push({name: 'shop-by-tag', params: {tag: this.sections[0].url}})
              }

            })
        },

        triggerSnackbar(qty) {
          if(!this.user.email.includes('guest.quomi.it') && this.order.getPlanPricePerPortion().toFixed(2) != "4.45"){
            window.dispatchEvent(new CustomEvent('trigger-snackbar-recipes', { 
              bubbles: true,
              detail:qty
            }));
          }
        },
        recipeAction ($event) {
            var recipe = $event.recipe;
            var quantity = $event.quantity;
            var cookies = container.get('services.cookies')

            let showDouble = quantity == 1 && cookies.get('people') == 4;

            if ($event.action !== 'remove') {
               this.triggerSnackbar(showDouble ? 2 : 1)
            }

            if ($event.action == 'add' && showDouble) {
               quantity = 2;
            }


            if (this.updating) return
            this.updating = true
            this.$_orderAction_updateRecipe(recipe, quantity).then(i => {
                this.updating = false
            })

        },

        passToNextStep () {
            this.$router.push({ name: 'verify-page' })
        },

        billToggle () {
            this.$refs.bill.toggle()
        },

        updateUserView () {
            var user = this.user
            user.subscription = this.subscriptionStore.subscription
            user.order = this.orderStore.order

            this.$root.updateUser(user)
        },

        confirm () {
            this.goToNextStep();
        },
        goToNextStep()
        {
            this.$router.push({ name: 'verify-page' })
        },
        loadUser()
        {
            let user = this.$root.user;

            if (!user || !user.subscription) {
                this.guest = true;
                let rep = new Repository();
                return rep.createGuestWithEmtpyOrder().then(i => {
                    this.guest = false;
                })
            }

            return Promise.resolve(1)
        },
        loadTheUniverse() {

            this.confirmCallback = (e) => {
                    this.goToNextStep();
            }
            window.addEventListener('billing-cart-confirm', this.confirmCallback);

            let rep = new Repository();
            rep.retrieveOrCreateOrder().then(i => {
                return this.loadMenu()
            }).then(i => {
              if (this.menu.first_available) {
                return this.load()
              }
            }).finally(i => {
                this.innerLoading = false;
            })

        },
        openBox() {
          this.openedBox = !this.openedBox
        },

        openSortBox() {
          this.openedSortBox = !this.openedSortBox
        },

        toggleFilters() {
            this.openedFilters = !this.openedFilters
        },

        toggleSorting(){
            this.openedSorting = !this.openedSorting
        },
        removeBanner() {
            this.banner = false
        },

        historyBack() {
            if(this.pathsWithSections.includes(this.$route.path)) {
                return this.$router.push({name: 'shop'})
            }
            return history.back()
        },

        loadConfirmedOrder() {
			var um = new UserApi()
			um.orders({
				page: 1,
				show: 1,
				sort: '-created_at',
				query: 'status != "canceled" and (status != "pending" or (status = "pending" and confirmed_at is not null and ok = 1))'
			}).then(response => {
				let orders = response.body.resources.filter(order => {
					return new Order(order)
				})
				if(orders.length > 0) {
					this.lastConfirmedOrder = orders.find(order => (order.is_pending && order.date.confirmed_at !== null) || (order.recurring && order.is_pending && order.date.confirmed_at !== null))
				}
			})
		},
        dateCutOff () {
	    	return this.$_dates_readableDate(this.lastConfirmedOrder.date.cutoff)
	    },
    },

    mounted () {

        let user = this.$root.user;

        var cookies = container.get('services.cookies')

        if (!user && !cookies.get('people') && this.$root.source !== 'bennet') {
          return this.$router.push({name: 'plans'});
        }

        this.innerLoading = true;

        let rep = new Repository();
        rep.retrieveOrCreateOrder().catch(e => {
          return this.$router.push({ name: 'unavailable' })
        }).then(i => {


          this.loadTheUniverse()
        }).finally(i => {

        }) 
        
        this.loadConfirmedOrder()
    },

    destroyed () {
        window.removeEventListener('billing-cart-confirm', this.confirmCallback);
        window.removeEventListener('checkout-menu-changed', this.onChangeDelivery);
        window.removeEventListener('remove-filters', this.clearFilters)
    },
    created () {
        this.onChangeDelivery = () => {
            this.loadProducts();
            this.loadMenu();
        };

        window.addEventListener('checkout-menu-changed', this.onChangeDelivery);

        window.addEventListener('scroll', (e) => {
            this.sticky = window.pageYOffset > 250;
        })

        window.addEventListener('remove-filters', this.clearFilters)
    }
}

</script>
<style>
    .slick-slide {
        outline: none !important;
    }
    .slick-track {
        margin: auto;
    }
    .slider-arrow {
        box-shadow: none !important;
    }
    .items-container {
        padding: 0 !important;
    }

    .slick-slide:not(.slick-active) {
        height: 0;
    }

    .v-menu__content {
        border: 2px solid var(--quomi-primary) !important;
        box-shadow: none !important;
        margin-top: 3px !important;
        background: white;
    }

    .v-label.theme--light {
        color: var(--quomi-primary);
        font-weight: 500;
        margin: 0;
    }

    .v-list-item__title {
        font-size: 15px !important;
        font-weight: 400 !important;
    }

    .v-select__selections {
        padding-bottom: 5px;
    }

    .v-text-field > .v-input__control > .v-input__slot:after,
    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: var(--quomi-primary) !important;
    }
</style>

<style scoped>
.disabled {
  opacity: 0.2;
}
.overlay {
    position: fixed;
    top: 0px;
    left: 0;
    background-color: white;
    width: 100%;
    height: 100vh;
    z-index: 5;
    overflow-y: auto;
}

.filters-viewpoint {
    margin-top: 17vh;
}

.filter-item {
    margin-top: 10px;
    margin-right: 10px;
    border: 1.5px solid #ededed;
    padding: 10px;
    white-space: nowrap;
    border-radius: 4px;
}

.filters-footer {
    position: fixed;
    bottom: 0;
    border-top: 1px solid #ededed;
    width: 100%;
    padding: 10px;
    background: white;
}

input[type='checkbox'] {
    appearance:none;
    display: flex;
    justify-content: center;
    align-items: center;
    width:1.5rem;
    height:1.5rem;
    background:white;
    border-radius:5px;
    border:2px solid var(--quomi-primary);
}

input[type='checkbox']:checked::before {
    font-family: "Font Awesome 5 Free"; 
    font-weight: 900;
    color: var(--quomi-primary); 
    content: "\f00c";
}
/* .container {
    background-color: #fcfcfc;
} */

.container.fixed {
    max-height: 100vh;
    overflow: hidden;
}

.content-layout {
    display: flex;
}

* >>> .toggle {
    font-size: 23px;
}

.placeholder-line {
    height: 30px;
    width: 100%;
    background-color: #ededed;
}

.recipes {
    flex-basis: 100%;
    max-width: 100%;
    padding: 50px 0px 0 0px; 
}

.recipes-listing {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 -10px 30px -10px;
    align-items: flex-start;
    padding:0 60px;
}

.recipe-box {
    flex-basis: calc(100% / 4 - 20px);
    max-width: calc(100% / 4 - 20px);
    margin: 10px;
}

.recipe-modal .recipe-name {
    font-size: 20px;
    padding: 10px 0;
}

.logos img {
    width: auto;
    max-height: 45px;
    margin: 10px;
}

.filter-btn {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
}

.filter-btn:hover{
  cursor: pointer;
}

.filter-btn-mobile {
    width: 45%;
    border: 2px solid #ededed;
    border-radius: 4px;
    font-size: 16px;
    padding: 10px;
    margin: 20px 10px;
    background: white;
}

.cat_box {
    display: flex;
    flex-direction: column;
    border: 3px solid var(--quomi-primary);
    border-radius: 5px;
    padding: 10px;
    position: absolute;
    z-index: 2;
    background-color: white;
    width: fit-content;
}

.cat_box_sort {
    position: absolute;
    right: 57px;
}

.fa {
    transition: all .1s ease;
    padding: 0 7px;
}
.rotated {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
}

.banner {
    display: flex;
    align-items: center;
    justify-content: end;
    background-image: url('https://api.quomi.it/oldimg/martini-kit-aperitivo-quomi.webp');
    background-position: center 45%;
    background-repeat: no-repeat;
    background-size: cover;
    height: 350px;
    width: calc(100vw - 120px);
}

.banner-2 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    height: 400px;
    width: calc(100vw - 120px);
}

ul > li {
    margin-left: 20px;
}

.top-banner {
    width: 100%;
    padding: 10px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--quomi-primary);
    font-size: 12px;
    color: #fff;
    text-align: center;
    position: relative;
}

@media (max-width: 1324px) {
    .recipe-box {
        flex-basis: calc(100% / 3 - 20px);
        max-width: calc(100% / 3 - 20px);
    }

    .with-banners {
        flex-basis: calc(100% / 4 - 20px);
        max-width: calc(100% / 4 - 20px); 
    }
}

@media (max-width: 900px) {
    .recipe-box {
        flex-basis: calc(100% / 2 - 20px);
        max-width: calc(100% / 2 - 20px);
    }

    .section-container {
        width: 100%;
    }

    .banner-2 {
    flex-direction: column;
    }

    .banner-2  h2 {
        text-align: center;
    }
}


@media (max-width: 640px) {
    p.center {
        padding: var(--recipes-padding-mobile)
    }
    .recipes-listing {
        padding: var(--recipes-padding-mobile)
    }
    .recipe-box {
        flex-basis: calc(100% / 1 - 20px);
        margin: var(--recipes-box-margin-mobile);
        min-height: 315px;
        height: auto;
    }

    .recipe-extra-box {
        height: auto;
    }

    .extra-box {
        height: 350px;
    }
  
    .banner,
    .banner-2 {
        width: calc(100vw - 25px);
        text-align: center;
    }

    .banner-2 > img {
        max-width: 60%;
    }

    ul > li {
        font-size: 12px;
    }
}

.section-container {
    margin: 10px auto 0 auto;
}

.section-item {
    text-align: center;
    cursor: pointer;
    outline: none !important;
    margin: 0 !important;
}


@media (max-width: 1024px) {
    .section-item.active {
        border-bottom: 2px solid var(--quomi-primary);
    }

    .section-item {
        padding-bottom: 10px;
    }

    .section-item span{
        margin-top: 10px;
    }

    .top-banner {
        top: 43px;
    }
}

.section-item span{
    display: block;
    color: #54545b;
    font-size: 15px;
    font-weight: 700;
}

.section-item.active span{
    color: var(--quomi-primary);
}

.my-swipe {
  height: 200px;
  color: #fff;
  font-size: 30px;
  text-align: center;
}

.slide1 {
  background-color: #0089dc;
  color: #fff;
}

.slide2 {
  background-color: #ffd705;
  color: #000;
}

.slide3 {
  background-color: #ff2d4b;
  color: #fff;
}

.section-container-box {
    width: 110px;
    border:2px solid transparent; 
    padding: 5px; 
    display: inline-block;
    border-radius: 10px;
}

.section-container-ct:not(.sticky) .section-item.active .section-container-box {
    border:2px solid var(--quomi-primary); 
}

.section-container-ct {
    margin-top: -31px;
    margin-bottom: 20px;
    position: fixed !important;
    left: 0;
    width: 100%;
    z-index: 2;
    background: white;
}


.border-top-checkout {
    margin-top: -2px;
    border-top: 2px solid grey
}

@media (min-width: 1024px) {
    .section-container-ct {
        margin-top: -180px;
    }

    .border-top-checkout {
        margin-top: 10px;
    }
}

@media (min-width: 768px) and (max-width: 1024px){
    .filter-btn-mobile {
        margin: 20px 55px;
    }

    .banner-2 > img {
        width: 40%;
    }
}

@media (min-width: 1920px) {
    .banner {
        width: calc(100vw - 136px);
    }
}
</style>
